module.exports = __webpack_public_path__ + "static/media/twitter.8c2f571c.svg";